import React from 'react';
import { Flex, Button } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import DetailListCard from "../shared/DetailListCard.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  tIcon
} = I18N.ns('ui-attributes.detail.selection.SelectionListCard');
export default function SelectionListCard(props) {
  const {
    headerControls,
    onClose
  } = props;
  const nHeaderControls = typeof onClose === 'function' ? /*#__PURE__*/_jsxs(Flex, {
    variant: "rowS",
    align: "center",
    children: [headerControls, /*#__PURE__*/_jsx(Button, {
      variant: "closeSelection|close",
      icon: tIcon('close'),
      onClick: onClose
    })]
  }) : headerControls;
  return /*#__PURE__*/_jsx(DetailListCard, {
    ...props,
    headerControls: nHeaderControls
  });
}